"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "caption1StrongerClassNames", {
    enumerable: true,
    get: function() {
        return _useCaption1Strongerstyles.caption1StrongerClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Caption1Stronger"), exports);
const _useCaption1Strongerstyles = require("./useCaption1Stronger.styles");
